import type { PropertyData } from '@strata-monorepo/shared-types'
import { isFieldUsable, REQUIRED_HOME_INFO_FIELDS } from './homeInfoFields'

/**
 * Returns true when all five required home detail fields are present AND non-imputed.
 * An imputed field is treated the same as a missing field — the user must supply the exact value.
 */
const validateEnrichedCustomerPropertyData = (propertyData: PropertyData): boolean => {
  if (!propertyData) {
    return false
  }

  return REQUIRED_HOME_INFO_FIELDS.every((field) =>
    isFieldUsable(field.getValue(propertyData), field.getImputed(propertyData)),
  )
}

export default validateEnrichedCustomerPropertyData
